import "./App.css";
import { Routes, Route } from "react-router-dom";
import { publicRoutes, privateRoutes } from "./routes";

function App() {
  return (
    <>
      <Routes>
        {publicRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.component} />
        ))}
      </Routes>
      <Routes>
        {privateRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.component} />
        ))}
      </Routes>
    </>
  );
}

export default App;
